import { defineStore } from "pinia";
import { LLMCasesMap } from "@/models";
import { getCasesForType } from "@/api/cases";
import { groupItemsByDate, mergeLLMCasesByDate } from "@/utils/timeUtils";

const PAGE_SIZE = 50;

export const useLLMCaseListStore = defineStore("llmCaseList", {
  state: () => ({
    cases: {} as LLMCasesMap,
    pagination: {
      total: 0,
      current: 1,
      size: PAGE_SIZE,
    },
  }),
  actions: {
    async updateCaseList() {
      this.pagination.current = 1;
      const params = new URLSearchParams();
      params.append("size", this.pagination.size.toString());
      params.append("page", (this.pagination.current - 1).toString());
      const caseList = await getCasesForType("llm", params);
      this.pagination.current = caseList.number + 1;
      this.pagination.total = caseList.totalPages;
      this.cases = groupItemsByDate(caseList.content);
    },
    async loadMoreCases() {
      this.pagination.current += 1;
      const params = new URLSearchParams();
      params.append("size", this.pagination.size.toString());
      params.append("page", (this.pagination.current - 1).toString());
      const caseList = await getCasesForType("llm", params);
      this.pagination.current = caseList.number + 1;
      this.pagination.total = caseList.totalPages;
      this.cases = mergeLLMCasesByDate(this.cases, groupItemsByDate(caseList.content));
    },
  },
});
